import { API_END_POINT, get } from '../Core/http';
import {ANY_ONE} from '../Core/constants';
import {getQueryVariable, checkProductsIsValid, checkEmployeeIsValid, roundDuration, countDurationSelected} from '../Core/utils';
import { setAppointmentField } from 'jsTheme/Actions/Appointments.action';
import {setTimeLineField} from './TimeLine.action';
import {getFirstDateofWeek} from '../Core/date';
export const SET_HISTORY_FIELD = 'SET_HISTORY_FIELD';

export const getApptDetail = () => async (dispatch, getState) => {
    let id = '';
    if(getQueryVariable('apptId')) id = getQueryVariable('apptId');
    
    if(id === '') return false;

    let stateStore = getState(),        
        {products: listProducts, productResources, employeeProducts, employees: listEmployees,shop, timelines} = stateStore,
        url = `${API_END_POINT}/v1.6/appointment/info?id=` + id;
    try {
        let rawResult = await get(url),
        jsonResult = await rawResult.json();
        if(jsonResult.status === 0){
            let {products, employees, booker: bookerInfo, fromTime, toTime, scheduleDate, id} = jsonResult.appointment,
                newBookerInfo = {
                    birthDate: bookerInfo.birthDate || '',
                    customerName: bookerInfo.displayName || '',
                    email: bookerInfo.emailAddress || '',
                    fullName: bookerInfo.fullName || '',
                    phoneNumber: bookerInfo.phoneNumber || '',
                    message: bookerInfo.notes || ''
                },
                listIdProducts = products.map(item => item.id),
                storeage = localStorage.getItem('infoData') ? JSON.parse(localStorage.getItem('infoData')) : null;
            storeage = {...storeage, ...newBookerInfo};
            dispatch(_setHistoryField([
                {key: 'apptId', value: id},
                {key: 'typeAppt', value:'edit'}
            ])) 
            const checkProductValid = checkProductsIsValid(products, listProducts, employeeProducts, productResources);
            if(checkProductValid){
                let totalDuration = countDurationSelected(listIdProducts, listProducts),
                    roundDurationProducts = roundDuration(totalDuration, shop.timeBlock),
                    newScheduleDate = getFirstDateofWeek(timelines.selectedCalendar, scheduleDate),
                    employeeValid = employees[0] ? employees[0].id : '', 
                    statusCheckEmployeeIsValid = checkEmployeeIsValid(employees[0], listEmployees, shop, employeeProducts);

                localStorage.setItem('selectedProduct', JSON.stringify(listIdProducts));                

                              
                if(!statusCheckEmployeeIsValid.status){
                    if(statusCheckEmployeeIsValid.isAnyOne){
                        employeeValid = ANY_ONE;
                    }else{
                        employeeValid = ''
                    }
                }
                dispatch(setAppointmentField([
                    {key: 'selectedProducts', value: listIdProducts},
                    {key: 'selectedEmployees', value: employeeValid},
                    {key: 'selectedCalendar', value: scheduleDate},
                    {key: 'selectedTimeline',value: {from: fromTime,to: toTime}}
                ]));                  
                dispatch(setTimeLineField([
                    {key: 'selectedCalendar', value: newScheduleDate},
                    {key: 'serviceDuration', value: roundDurationProducts}                    
                ]));
                return {products: true, employees: employeeValid !== '', calendar: true}
            }else{
                return {products: false, employees: false, calendar: false}
            }                       
        }
        return {products: false, employees: false, calendar: false};
    } catch (error) {
        return false
    }
}
export const setHistoryField = (list) => (dispatch, getState) => {
    dispatch(_setHistoryField(list))
}
const _setHistoryField = (listValue) => ({
    type: SET_HISTORY_FIELD,
    payload: {
        listValue
    }
})